/** WYSIWYG preview de un slide del dossier dentro del editor.
 *
 *  Pequeño wrapper que delega el render real a `DossierSlide` (compartido con
 *  el Modo Presentación 16:9). Esto garantiza que el preview del editor y la
 *  presentación en vivo se vean idénticos.
 */
import DossierSlide, {
  LAYOUT_OPTIONS,
  LAYOUT_LABELS,
} from "@/components/dossier/DossierSlide";

export { LAYOUT_OPTIONS, LAYOUT_LABELS };

export default function SlidePreview({ section, project, layout, onChangeLayout }) {
  // Layout efectivo: migración silenciosa de "magazine-spread" (retirado en
  // Feb 2026) a "text-image-right" para que el dropdown y el render coincidan.
  const rawLayout = layout || "";
  const effective = rawLayout === "magazine-spread" ? "text-image-right" : rawLayout;
  return (
    <div className="overflow-hidden rounded-xl border border-[#2C2B29]/15 bg-[#FAFAF6] shadow-inner">
      <header className="flex items-center justify-between border-b border-[#2C2B29]/10 bg-white px-3 py-2">
        <p className="text-[9px] font-semibold uppercase tracking-[0.3em] text-[#2C2B29]/55">
          Slide · {LAYOUT_LABELS[effective || "auto"] || effective}
        </p>
        {onChangeLayout && (
          <LayoutSelect value={layout} onChange={onChangeLayout} sectionKey={section.key} />
        )}
      </header>
      <div className="relative w-full" style={{ aspectRatio: "16 / 9", containerType: "inline-size" }}>
        <div className="absolute inset-0">
          <DossierSlide section={section} project={project} layout={effective} />
        </div>
      </div>
    </div>
  );
}

function LayoutSelect({ value, onChange, sectionKey }) {
  return (
    <select value={value || ""} onChange={(e) => onChange(e.target.value)}
            data-testid={`layout-select-${sectionKey}`}
            className="rounded border border-[#2C2B29]/15 bg-white px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.18em] text-[#2C2B29]/75 outline-none focus:border-[#941620]">
      {LAYOUT_OPTIONS.map((o) => (<option key={o.value || "auto"} value={o.value}>{o.label}</option>))}
    </select>
  );
}
